import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PublicBooking from './pages/PublicBooking';

function App() {
  return (
    <Router>
      <Routes>
        {/* Direct slug on root: book.truzie.co.in/truzie-international */}
        <Route path="/:slug" element={<PublicBooking />} />
        {/* Also support /book/:slug for backward compat */}
        <Route path="/book/:slug" element={<PublicBooking />} />
        {/* Root redirects to main firm page */}
        <Route path="/" element={<Navigate to="truzie-international" replace />} />
        {/* 404 */}
        <Route path="*" element={
          <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f8fafc'}}>
            <div style={{textAlign:'center'}}>
              <h1 style={{fontSize:'2rem',fontWeight:700,color:'#1e293b'}}>Page Not Found</h1>
              <p style={{color:'#64748b',marginTop:'0.5rem'}}>The booking page you're looking for doesn't exist.</p>
              <a href="/" style={{display:'inline-block',marginTop:'1rem',padding:'0.5rem 1.5rem',background:'#1E40AF',color:'white',borderRadius:'0.5rem',textDecoration:'none'}}>Go to Booking</a>
            </div>
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
